const CYRILLIC_TO_LATIN = {
  а: "a",
  б: "b",
  в: "v",
  г: "g",
  д: "d",
  е: "e",
  ё: "e",
  ж: "zh",
  з: "z",
  и: "i",
  й: "y",
  к: "k",
  л: "l",
  м: "m",
  н: "n",
  о: "o",
  п: "p",
  р: "r",
  с: "s",
  т: "t",
  у: "u",
  ф: "f",
  х: "h",
  ц: "ts",
  ч: "ch",
  ш: "sh",
  щ: "sch",
  ъ: "",
  ы: "y",
  ь: "",
  э: "e",
  ю: "yu",
  я: "ya",
};

export function transliterateToLatin(str) {
  return String(str)
    .toLowerCase()
    .split("")
    .map((char) => CYRILLIC_TO_LATIN[char] ?? char)
    .join("");
}

/** Одно слово без пробелов — подходит для автоподдомена. */
export function isSingleWordClubName(name) {
  const trimmed = String(name || "").trim();
  if (!trimmed) return false;
  return trimmed.split(/\s+/).filter(Boolean).length === 1;
}

/**
 * Поддомен из названия клуба: только если одно слово.
 * Кириллица → латиница, только a-z, 0-9, дефис, 2–32 символа.
 */
export function subdomainFromClubName(clinicName) {
  if (!isSingleWordClubName(clinicName)) return "";

  const word = String(clinicName).trim().split(/\s+/).filter(Boolean)[0];
  const subdomain = transliterateToLatin(word)
    .replace(/[^a-z0-9-]/g, "")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "")
    .slice(0, 32);

  return subdomain.length >= 2 ? subdomain : "";
}
